import { render, staticRenderFns } from "./BusinessAttireCarousel.vue?vue&type=template&id=4500cf85&"
import script from "./BusinessAttireCarousel.vue?vue&type=script&lang=js&"
export * from "./BusinessAttireCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports